// @flow

import { compose } from 'redux';
import withRoute from '../withRoute';
import withSettings from '../withSettings';

export default compose(
  withRoute(),
  withSettings(),
)(({ children }) => children);
